import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Separator } from '@lb-service/ui';
import appUtils from '../../../utils/appUtils';

const Footer = () => {
  const router = useRouter();
  const { locale: currentLocale } = router;
  const { t } = useTranslation('common');
  let tradeInJapan = null;
  let facebookLink = 'https://www.facebook.com/lingualbox';
  let twitterLink = 'https://twitter.com/lingualbox';
  let termsLink = '/terms';
  let privacyLink = '/privacy';
  let blog = null;
  if (currentLocale === 'ja') {
    tradeInJapan = (
      <li>
        <Link href="/trade">特商法に基く表記</Link>
      </li>
    );
    blog = (
      <li>
        <a href="http://ja.lingualbox.com/blog">ブログ</a>
      </li>
    );
    termsLink = '/terms-ja';
    privacyLink = '/privacy-ja';
    facebookLink = 'https://www.facebook.com/lingualbox.jp';
    twitterLink = 'https://twitter.com/lingualbox_jp';
  } else if (currentLocale === 'tw') {
    facebookLink = 'https://www.facebook.com/lingualbox.com.tw';
    twitterLink = 'https://twitter.com/lingualbox_tw';
  } else if (currentLocale === 'es') {
    facebookLink =
      'https://www.facebook.com/LingualBox-Aprender-a-hablar-inglés-online-524980884352619';
    twitterLink = 'https://twitter.com/lingualbox_es';
  } else if (currentLocale === 'pt') {
    facebookLink = 'https://www.facebook.com/lingualbox.com.br';
    twitterLink = 'https://twitter.com/lingualbox_br';
  } else if (currentLocale === 'ru') {
    twitterLink = 'https://twitter.com/lingualbox_ru';
  } else {
    blog = (
      <li>
        <a href="https://www.lingualbox.com/blog/">Blog</a>
      </li>
    );
  }
  let comparisonContent = <div />;
  if (currentLocale === 'ja') {
    comparisonContent = (
      <div>
        <div className="section-title">比較する</div>
        <ul className="list-layout">
          <li>
            <Link href={`/comparison/${'personal-tutor-vs-online-school'}`}>
              個人英会話講師との比較
            </Link>
          </li>
          <li>
            <Link href={`/comparison/${'learn-in-the-philippines'}`}>
              フィリピン留学との比較
            </Link>
          </li>
          <li>
            <Link href={`/comparison/${'tickets-vs-daily'}`}>
              毎日プラン型サービスとの比較
            </Link>
          </li>
          <li>
            <Link href={`/comparison/${'online-school-vs-english-bootcamp'}`}>
              英語学習ブートキャンプとの比較
            </Link>
          </li>
          <li>
            <Link href={`/comparison/${'one-to-one-vs-group'}`}>
              グループレッスンとの比較
            </Link>
          </li>
          <li>
            <Link href={`/comparison/${'offline-english-school'}`}>
              通学型英会話教室との比較
            </Link>
          </li>
          <li>
            <Link href={`/comparison/${'language-exchange'}`}>
              ランゲージ・エクスチェンジとの比較
            </Link>
          </li>
        </ul>
      </div>
    );
  }
  return (
    <footer id="footer" className="lb-footer sm-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="grid grid-cols-12 gap-4">
          <div className="sm:col-span-3 mb-8">
            <div className="section-title">{t('service.footer.site')}</div>
            <ul className="list-layout">
              <li>
                <Link href="/">{t('links.home')}</Link>
              </li>
              <li>
                <Link href="/school/learn-spoken-english">
                  {t('links.school')}
                </Link>
              </li>
              <li>
                <a href={appUtils.getAppPath(currentLocale, 'tutors')}>
                  {t('links.tutors')}
                </a>
              </li>
              <li>
                <Link href="/courses">{t('links.courses')}</Link>
              </li>
              <li>
                <Link href="/pricing">{t('links.pricing')}</Link>
              </li>
            </ul>
            <div className="mt-4 ros-space-sm-4">
              <div className="section-title">{t('service.footer.support')}</div>
              <ul className="list-layout">
                <li>
                  <Link href="/faq">{t('links.faq')}</Link>
                </li>
                <li>
                  <a href="mailto:support@lingualbox.com">
                    support@lingualbox.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="sm:col-span-3 mb-8">
            <div className="section-title">{t('service.footer.legal')}</div>
            <ul className="list-layout">
              <li>
                <Link href={termsLink}>{t('links.terms')}</Link>
              </li>
              <li>
                <Link href={privacyLink}>{t('links.privacy')}</Link>
              </li>
              {tradeInJapan}
            </ul>
          </div>
          <div className="sm:col-span-3 mb-8 hide-sm">{comparisonContent}</div>
          <div className="sm:col-span-3 mb-8">
            <div className="section-title">{t('service.footer.connect')}</div>
            <ul className="list-layout">
              <li>
                <a href={facebookLink}>Facebook</a>
              </li>
              <li>
                <a href={twitterLink}>Twitter</a>
              </li>
              {blog}
            </ul>
          </div>
        </div>
        <Separator />
        <div className="text-center">
          <div className="mt-4 text-secondary">© LingualBox, Inc.</div>
        </div>
      </div>
    </footer>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default Footer;
